import React, { useEffect, useState } from "react";
import "../styles.css";
import { setKeyboardWalkthrough } from "../../../Services/userSettings";
import { useNavigate } from "react-router-dom";

const KeyboardHomeV2 = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(0); // 0 welcome, 1..n tutorial, -1 done
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      const flag = localStorage.getItem("keyboard_walkthrough_done");
      if (flag === "true") {
        setStep(-1);
        setDismissed(true);
      } else {
        setTimeout(() => setStep(1), 500);
      }
    } catch (_) {
      setTimeout(() => setStep(1), 500);
    }
  }, []);

  const finishTutorial = async () => {
    setStep(-1);
    setDismissed(true);
    try { localStorage.setItem("keyboard_walkthrough_done", "true"); } catch (_) {}
    try { await setKeyboardWalkthrough(true); } catch (_) {}
  };

  const TutorialBubble = ({ title, desc }) => (
    <div className="tutv2-bubble">
      <div className="tutv2-title">{title}</div>
      <div className="tutv2-desc">{desc}</div>
      <div className="tutv2-controls">
        {step < 3 && (
          <button className="tutv2-next" onClick={() => setStep(step + 1)}>Next →</button>
        )}
        {step === 3 && (
          <button className="tutv2-next" onClick={finishTutorial}>Finish →</button>
        )}
      </div>
    </div>
  );

  const goToDashboard = () => navigate("/dashboard");

  const dimClass = step > 0 ? "dim-others" : "";

  return (
    <div className="homev2-wrap">
      <div className={`homev2-keyboard ${dimClass}`}>
        <div className="homev2-orb" aria-hidden />
        <h2 className="homev2-title">Welcome to chat coaching</h2>

        <div className={`homev2-chat-cta ${step === 1 ? "spotlight" : ""}`}>What’s on your mind?</div>
        <div className={`homev2-toolbar ${step === 2 ? "spotlight" : ""}`}>
          <div className="homev2-tool">New chat</div>
          <div className="homev2-tool">History</div>
          <div className="homev2-tool">Settings</div>
        </div>
        <div className={`homev2-stt ${step === 3 ? "spotlight" : ""}`}>
          <div className="homev2-chip">Use speech-to-text for quick notes</div>
        </div>

        {step === 1 && (
          <TutorialBubble title="Tutorial - New Chat" desc="Start a new chat by typing a message." />
        )}
        {step === 2 && (
          <TutorialBubble title="Tutorial - History" desc="Access your recent conversations here." />
        )}
        {step === 3 && (
          <TutorialBubble title="Tutorial - Speech to Text" desc="Use speech-to-text to quickly capture thoughts." />
        )}
      </div>
      {dismissed && (
        <div className="homev2-actions">
          <button className="nav-continue" onClick={goToDashboard}>Go to dashboard →</button>
        </div>
      )}
    </div>
  );
};

export default KeyboardHomeV2;
